export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '魔法与异世界冒险' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血激战动作漫画' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', description: '烧脑悬疑推理故事' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默搞笑日常' },
  { slug: 'thriller', name: '惊悚', icon: 'ri-ghost-line', description: '惊险刺激恐怖漫画' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '感人至深剧情佳作' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', description: '青春校园成长故事' },
];

export const comics = [
  {
    id: 1,
    title: '绝世医仙在都市',
    author: '金泰亨',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20cover%20art%2C%20a%20handsome%20doctor%20in%20traditional%20hanbok%20holding%20a%20glowing%20herb%2C%20modern%20city%20background%20with%20mist%2C%20vibrant%20colors%2C%20dramatic%20lighting%2C%20manhwa%20webtoon%20aesthetic%2C%20clean%20simple%20background%20with%20warm%20tones&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 4.9,
    views: '1,286万',
    chapters: 218,
    status: '连载中',
    description: '天才医仙意外穿越到现代都市，凭借绝世医术在都市中掀起波澜。他不仅要面对各种疑难杂症，还要应对来自各方势力的挑战。',
    tags: ['穿越', '医术', '都市', '热血'],
    updateTime: '2026-08-05',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '总裁的秘密恋人',
    author: '李美妍',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%20art%2C%20a%20beautiful%20woman%20and%20handsome%20CEO%20in%20elegant%20attire%20sharing%20a%20tender%20moment%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20pastel%20colors%2C%20romantic%20webtoon%20style%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 4.8,
    views: '2,053万',
    chapters: 156,
    status: '连载中',
    description: '普通女孩意外成为冷酷总裁的秘密恋人，两人在身份悬殊中展开一段甜蜜又虐心的爱情故事。',
    tags: ['恋爱', '总裁', '都市', '甜宠'],
    updateTime: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '暗黑剑圣',
    author: '朴志成',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20action%20cover%20art%2C%20a%20powerful%20swordsman%20with%20dark%20armor%20wielding%20a%20flaming%20black%20sword%2C%20dramatic%20battle%20pose%2C%20dark%20atmospheric%20background%2C%20intense%20lighting%2C%20webtoon%20aesthetic&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    views: '987万',
    chapters: 189,
    status: '连载中',
    description: '被背叛的剑圣重生归来，带着前世的记忆与仇恨，踏上复仇之路。黑暗力量在他体内觉醒，他将成为最强大的暗黑剑圣。',
    tags: ['重生', '复仇', '战斗', '暗黑'],
    updateTime: '2026-08-05',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 4,
    title: '恶女的救赎',
    author: '崔秀晶',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20drama%20cover%20art%2C%20a%20noble%20woman%20in%20elaborate%20historical%20dress%20looking%20back%20with%20tears%2C%20palace%20background%2C%20emotional%20expression%2C%20warm%20golden%20lighting%2C%20historical%20romance%20webtoon%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 4.9,
    views: '1,567万',
    chapters: 201,
    status: '连载中',
    description: '沦为恶女标签的贵族千金，在一次意外后觉醒前世记忆，决心改变命运。她将用自己的方式，走出被诅咒的宿命。',
    tags: ['重生', '宫廷', '女性', '救赎'],
    updateTime: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 5,
    title: '星际猎手',
    author: '郑宇宙',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20Korean%20manhwa%20sci-fi%20cover%20art%2C%20a%20bounty%20hunter%20with%20high-tech%20gear%20in%20a%20spaceship%2C%20glowing%20neon%20lights%2C%20cyberpunk%20aesthetic%2C%20dynamic%20pose%2C%20vibrant%20colors%2C%20webtoon%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 4.6,
    views: '756万',
    chapters: 145,
    status: '连载中',
    description: '在遥远的未来，银河系中最强猎手穿梭于各星球之间，追捕最危险的星际罪犯。科幻与冒险的完美融合。',
    tags: ['科幻', '冒险', '星际', '未来'],
    updateTime: '2026-08-03',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 6,
    title: '诡异公寓',
    author: '韩镇浩',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20Korean%20manhwa%20thriller%20cover%20art%2C%20an%20eerie%20apartment%20building%20at%20night%20with%20mysterious%20shadows%2C%20a%20frightened%20resident%20looking%20up%2C%20dark%20moody%20atmosphere%2C%20cold%20tones%2C%20webtoon%20horror%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 4.5,
    views: '634万',
    chapters: 98,
    status: '连载中',
    description: '搬进廉价公寓的年轻人发现，每到深夜，走廊里总会传来诡异的脚步声。邻居们一个接一个消失，隐藏在公寓背后的恐怖真相逐渐浮出水面。',
    tags: ['恐怖', '悬疑', '都市', '灵异'],
    updateTime: '2026-08-02',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 7,
    title: '我的狐仙女友',
    author: '张美淑',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20romance%20cover%20art%2C%20a%20girl%20with%20fox%20ears%20and%20tail%20in%20school%20uniform%20blushing%2C%20cherry%20blossom%20background%2C%20soft%20pink%20tones%2C%20adorable%20webtoon%20style%2C%20clean%20simple%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 4.8,
    views: '1,892万',
    chapters: 267,
    status: '连载中',
    description: '平凡高中生意外救下一只受伤的白狐，没想到白狐竟化作美少女，誓要报答他的恩情。甜蜜搞笑的校园恋爱喜剧就此展开。',
    tags: ['恋爱', '妖怪', '校园', '搞笑'],
    updateTime: '2026-08-05',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 8,
    title: '全职高手之巅峰',
    author: '柳承浩',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manhwa%20esports%20cover%20art%2C%20a%20pro%20gamer%20with%20headset%20in%20intense%20competition%2C%20keyboard%20and%20mouse%20with%20energy%20effects%2C%20stadium%20crowd%20background%2C%20dynamic%20colors%2C%20webtoon%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 4.7,
    views: '876万',
    chapters: 178,
    status: '连载中',
    description: '退役电竞选手重返赛场，带领新人队伍从零开始冲击世界冠军。电竞世界的热血与激情，友情与梦想的交织。',
    tags: ['电竞', '热血', '竞技', '团队'],
    updateTime: '2026-08-04',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 9,
    title: '宫廷药膳师',
    author: '尹慧珍',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Korean%20manhwa%20palace%20cover%20art%2C%20a%20female%20chef%20in%20traditional%20hanbok%20preparing%20herbal%20dishes%20in%20royal%20kitchen%2C%20warm%20steam%20and%20aromatic%20herbs%2C%20golden%20lighting%2C%20elegant%20webtoon%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 4.9,
    views: '1,123万',
    chapters: 234,
    status: '已完结',
    description: '现代营养师穿越到古代朝鲜宫廷，凭借现代营养学知识和药膳技艺，在宫廷中开创属于自己的传奇。',
    tags: ['穿越', '宫廷', '美食', '医疗'],
    updateTime: '2026-07-30',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 10,
    title: '搞笑一家人',
    author: '金贤秀',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20family%20comedy%20cover%20art%2C%20a%20chaotic%20family%20with%20exaggerated%20expressions%20sitting%20at%20dinner%20table%2C%20bright%20colorful%20style%2C%20humorous%20webtoon%20aesthetic%2C%20clean%20simple%20warm%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 4.6,
    views: '567万',
    chapters: 112,
    status: '连载中',
    description: '一家四口的爆笑日常生活，每个家庭成员都有独特的搞笑天赋。温馨治愈又让人捧腹大笑的家庭喜剧。',
    tags: ['搞笑', '家庭', '日常', '治愈'],
    updateTime: '2026-08-03',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 11,
    title: '亡灵法师的崛起',
    author: '朴俊宇',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20necromancer%20cover%20art%2C%20a%20mysterious%20mage%20in%20dark%20robes%20summoning%20skeleton%20warriors%2C%20purple%20magical%20energy%2C%20gothic%20atmosphere%2C%20dramatic%20lighting%2C%20webtoon%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 4.5,
    views: '489万',
    chapters: 134,
    status: '连载中',
    description: '被世人唾弃的亡灵法师，在不死族与人类的战争中找到了自己存在的意义。他将率领亡灵大军，改写大陆的历史。',
    tags: ['魔法', '亡灵', '战争', '黑暗'],
    updateTime: '2026-08-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 12,
    title: '校园侦探社',
    author: '安宰贤',
    category: 'suspense',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20Korean%20manhwa%20school%20detective%20cover%20art%2C%20three%20students%20with%20magnifying%20glass%20investigating%20in%20school%20corridor%2C%20suspenseful%20atmosphere%2C%20soft%20natural%20light%20from%20windows%2C%20intriguing%20webtoon%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 4.4,
    views: '345万',
    chapters: 89,
    status: '连载中',
    description: '高中生侦探社的三名成员，利用课余时间破解校园内外的各种神秘事件。每个案件背后都隐藏着意想不到的真相。',
    tags: ['推理', '校园', '侦探', '青春'],
    updateTime: '2026-07-28',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 13,
    title: '武道至尊',
    author: '权志龙',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Martial%20arts%20Korean%20manhwa%20cover%20art%2C%20a%20young%20martial%20artist%20in%20traditional%20training%20clothes%20performing%20powerful%20kick%2C%20energy%20aura%20surrounding%2C%20mountain%20temple%20background%2C%20inspiring%20webtoon%20style&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    rating: 4.8,
    views: '1,445万',
    chapters: 312,
    status: '连载中',
    description: '普通少年偶然获得上古武道秘籍，踏上通往武道至尊的征途。在强者为尊的世界里，他凭借不屈意志一步步攀登巅峰。',
    tags: ['武道', '修炼', '热血', '战斗'],
    updateTime: '2026-08-05',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 14,
    title: '公主的逆袭',
    author: '宋慧乔',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Royal%20Korean%20manhwa%20princess%20cover%20art%2C%20a%20determined%20princess%20in%20magnificent%20royal%20robe%20standing%20on%20palace%20balcony%2C%20sunset%20sky%2C%20golden%20crown%2C%20strong%20confident%20expression%2C%20elegant%20webtoon%20style&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    rating: 4.7,
    views: '1,034万',
    chapters: 189,
    status: '连载中',
    description: '被废黜的公主隐忍十年，暗中积蓄力量，终在王国危难之际强势回归，上演惊天逆袭。权谋与爱情交织的宫廷史诗。',
    tags: ['宫廷', '逆袭', '权谋', '女性'],
    updateTime: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 15,
    title: '末日生存指南',
    author: '郑大贤',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Apocalyptic%20Korean%20manhwa%20survival%20cover%20art%2C%20survivors%20with%20weapons%20in%20destroyed%20city%2C%20orange%20apocalyptic%20sky%2C%20zombies%20in%20distance%2C%20tense%20atmosphere%2C%20gritty%20webtoon%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    rating: 4.6,
    views: '678万',
    chapters: 167,
    status: '连载中',
    description: '末日降临，丧尸横行。一群普通人在绝境中求生，人性的光辉与黑暗在末世中展现得淋漓尽致。',
    tags: ['末日', '生存', '丧尸', '人性'],
    updateTime: '2026-08-02',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 16,
    title: '魔王的千层套路',
    author: '孙艺珍',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20fantasy%20Korean%20manhwa%20cover%20art%2C%20a%20demon%20king%20in%20funny%20embarrassing%20situation%2C%20chibi%20style%20characters%2C%20bright%20playful%20colors%2C%20humorous%20expression%2C%20clean%20simple%20webtoon%20style&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    rating: 4.5,
    views: '523万',
    chapters: 98,
    status: '连载中',
    description: '传说中的魔王其实是个社恐宅男？为了维护魔界威严，他每天都要绞尽脑汁想出各种套路来应付勇者和部下。',
    tags: ['搞笑', '魔王', '反差', '奇幻'],
    updateTime: '2026-08-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];

export const featuredBanners = [
  {
    id: 1,
    comicId: 9,
    title: '宫廷药膳师',
    subtitle: '穿越古今，药膳传奇',
    description: '现代营养师穿越古代宫廷，用精湛药膳技艺书写传奇人生。全网热度突破千万！',
    bgImage: 'https://readdy.ai/api/search-image?query=Beautiful%20historical%20Korean%20palace%20kitchen%20scene%2C%20elegant%20female%20chef%20in%20traditional%20hanbok%20preparing%20dishes%20with%20herbs%20and%20steam%2C%20warm%20golden%20sunlight%20streaming%20through%20wooden%20windows%2C%20rich%20textures%2C%20cinematic%20composition%2C%20soft%20bokeh&width=1600&height=700&seq=banner-hero-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 1,
    title: '绝世医仙在都市',
    subtitle: '医术盖世，都市称尊',
    description: '天才医仙穿越现代都市，绝世医术震撼世人。连载突破200话，热度不减！',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20handsome%20doctor%20in%20traditional%20Korean%20hanbok%20standing%20on%20modern%20city%20rooftop%20at%20sunset%2C%20glowing%20herbal%20energy%20in%20hands%2C%20dramatic%20sky%20with%20warm%20orange%20and%20pink%20tones%2C%20cinematic%20lighting%2C%20epic%20composition&width=1600&height=700&seq=banner-hero-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 13,
    title: '武道至尊',
    subtitle: '不屈意志，登顶巅峰',
    description: '上古秘籍在手，少年踏上武道至尊之路。312话连载中，热血不间断！',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20scene%2C%20young%20warrior%20in%20white%20training%20clothes%20on%20mountain%20peak%20surrounded%20by%20glowing%20energy%20aura%2C%20misty%20mountains%20in%20background%2C%20dramatic%20sunrise%20lighting%2C%20inspiring%20cinematic%20composition&width=1600&height=700&seq=banner-hero-03&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    comment: '韩漫网真的太好用了！更新速度快，画质清晰，分类也很齐全，已经推荐给身边所有喜欢韩漫的朋友了。',
    rating: 5,
  },
  {
    id: 2,
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20bright%20smile%2C%20modern%20casual%20look%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    comment: '在这里找到了好多冷门好漫画！推荐系统很准，每次都能发现新的宝藏漫画，每天不刷两话都睡不着。',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Asian%20man%20with%20glasses%20portrait%2C%20warm%20smile%2C%20intellectual%20look%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    comment: '页面简洁没有乱七八糟的广告，阅读体验超级好。免费还能看这么多优质韩漫，良心网站！',
    rating: 4,
  },
  {
    id: 4,
    name: '韩流少女',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20girl%20portrait%2C%20cute%20expression%2C%20trendy%20style%2C%20clean%20simple%20background%2C%20bright%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-user-04&orientation=squarish',
    comment: '作为韩流粉丝，韩漫网满足了我对韩国漫画的所有想象！从画风到剧情都超赞，每天都在等更新～',
    rating: 5,
  },
];